<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card class="px-0">
      <v-card-title class="headline pl-4 py-2 pr-2">
        Usuń Google Drive
        <v-spacer></v-spacer>
        <v-btn
          @click.native="visibility = false"
          icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4">
        Czy na pewno chcesz usunąć synchronizację z Google Drive?
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>

        <v-btn
          color="primary lighten-2"
          flat="flat"
          @click="setVisbility"
        >
          Anuluj
        </v-btn>

        <v-btn
          color="primary"
          :loading="busy"
          :disabled="busy"
          @click="saveGD"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getError } from '../../../helpers/helpers';
import { storeProfile } from '../../../repository/users';

export default {
  name: 'google-drive-remove-dialog',
  data: () => ({
    busy: false,
  }),
  computed: {
    ...mapGetters('users', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'google-drive-remove';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('users', [
      'setDialogVisbility',
    ]),
    ...mapActions('user', [
      'setGdAccess',
    ]),
    getError(errorData) {
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
    },
    async saveGD() {
      this.busy = true;
      try {
        await storeProfile({
          gd_client_id: null,
          gd_client_secret: null,
          gd_refresh_token: null,
          gd_folder_id: null,
        });
        this.$emit('refresh-profile');
        this.setGdAccess(false);
        this.setDialogVisbility(false);
        this.busy = false;
      } catch (e) {
        this.getError(e);
      }
    },
    setVisbility() {
      this.setDialogVisbility(false);
    },
  },
};
</script>
